import { render, staticRenderFns } from "./GlobalView.vue?vue&type=template&id=5a09b210"
import script from "./GlobalView.vue?vue&type=script&lang=js"
export * from "./GlobalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports